module.exports = __webpack_public_path__ + "static/media/cards-test.c1ff9b42.png";